import {ACTION_TYPE} from "utils/constants";

const initialState = {
  isPlaying: false,
  source: null,
  playingComponent: null,
};

const audioPlayer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.PLAY_AUDIO_PLAYER:
      return {
        ...state,
        isPlaying: true,
        source: action.payload.source,
        playingComponent: action.payload.component,
      };
    case ACTION_TYPE.STOP_AUDIO_PLAYER:
      return {
        ...state,
        isPlaying: false,
      };
    default:
      return state;
  }
};

export default audioPlayer;
